import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function DailyQuote() {
  const [quote, setQuote] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchQuote();
  }, []);

  const fetchQuote = async () => {
    try {
      const response = await axios.get(`${API}/moods/quote`);
      setQuote(response.data.quote);
    } catch (error) {
      console.error('Error fetching quote:', error);
      setQuote('Her gün yeni bir başlangıçtır. ✨');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="bg-gradient-to-r from-purple-100 to-pink-100 rounded-2xl p-6 animate-pulse">
        <div className="h-6 bg-purple-200 rounded w-3/4"></div>
      </div>
    );
  }

  return (
    <div 
      data-testid="daily-quote"
      className="bg-gradient-to-r from-purple-100 via-pink-100 to-blue-100 rounded-2xl p-6 shadow-lg hover-lift animate-fade-in"
    >
      <div className="flex items-center gap-3">
        <span className="text-3xl animate-pulse-slow">💭</span>
        <p className="text-lg font-medium text-gray-800 italic">"{quote}"</p>
      </div>
    </div>
  );
}